import React, { useEffect } from 'react';

// @ts-ignore
import { Field, getIn, useField, useFormikContext } from 'formik';

import { debounce, useDebounce } from '../../../hooks/useDebounce';
import { contextSelector } from '../../../helpers/helpers';

export const HsDebouncedField = (props) => {
    const { values, errors, initialValues } = useFormikContext();

    const context = contextSelector();

    const debouncedValue = useDebounce(getIn(values, props.name), 500);

    const [field, meta] = useField(props);

    useEffect(() => {
        if (meta.value !== initialValues[field.name] && !errors[field.name]) {
            debounce(context.handleChange([{ name: props.name, value: meta.value }]), 500, true);
        }
    }, [debouncedValue]);

    return <Field {...field} {...props} />;
};

export const HsField = (props) => {
    const { initialValues } = useFormikContext();

    const context = contextSelector();

    const [field, meta] = useField(props);

    useEffect(() => {
        if (meta.value !== initialValues[field.name]) {
            context.handleChange([{ name: props.name, value: meta.value }]);
        }
    }, [meta.value]);

    return <Field {...field} {...props} />;
};
